<template>
  <el-dialog class="editDialog" :append-to-body="true" width="600px" :visible.sync="showEditDialog"
    :close-on-click-modal="false" :destroy-on-close="true" @close="$emit('update:isShow', false)" :show-close="true">
    <div slot="title" class="title">
      {{ options.address_tag_id ? "编辑" : "新增" }}地址标签
    </div>

    <div class="content">
      <el-form label-width="6em" :model="form" :rules="rules" ref="form">

        <el-form-item label="名称" prop="title" ref="title">
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>

      </el-form>
    </div>

    <div slot="footer">
      <el-button type="success" :loading="submitLoading" @click="submit">保存</el-button>
      <el-button type="info" plain @click="$emit('update:isShow', false)">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mobile, email } from "@/regular";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      showEditDialog: false,
      submitLoading: false,
      form: {},
      groupData: [],
      positionOptions: [],
      rules: {
        title: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],

      },
    };
  },
  inject: ["refresh"],
  watch: {
    isShow: {
      immediate: true, //初始化立即执行
      handler: function (newVal) {
        this.$refs.form && this.$refs.form.resetFields();
        this.showEditDialog = newVal;
      },
    },
    options: {
      immediate: true, //初始化立即执行
      deep: true, //对象深度监测
      handler: function (newVal, oldVal) {
        const xxx = newVal;
        this.init(xxx);
      },
    },
  },
  created() { },
  methods: {

    init(options) {

      if (options.address_tag_id) {
        //编辑进来的会有id需要
        this.form = options;

      } else {
        this.form = {}
      }
    },
    submit() {
      this.$refs.form.validate((valid, obj) => {
        if (valid) {
          this.submitLoading = true;
          this.$api.addressTag.addressTag(
            {
              type: this.form.type,
              title: this.form.title,
            }.combination({
              address_tag_id: this.form.address_tag_id,
              method: this.form.address_tag_id ? "set.address_tag.item" : "add.address_tag.item",
            })
          )
            .then((res) => {
              this.submitLoading = false;
              this.refresh(1);
              this.$message.success("操作成功！");
            })
            .catch((err) => {
              this.submitLoading = false;
              console.log(err);
            });
        } else {
          this.scrollView(obj);
        }
      });
    },
  },
};
</script>
